import React from 'react';
import PropTypes from 'prop-types';

const SnackbarMessage = ({ theme, message, icon }) => (
    <span className={ theme.snackbarMessage }>
        { icon }
        { message }
    </span>
);

SnackbarMessage.propTypes = {
    theme: PropTypes.shape({}),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    icon: PropTypes.node,
};

export default SnackbarMessage;
